<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="manage-role-page">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.ManageRole") }}
        </div>
        <v-card-text>
          <div>
            <v-card elevation="10" class="role-filter-card">
              <v-row align="center">
                <v-col cols="12" sm="6" md="4" lg="4" style="margin-top: 25px;">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataRoleList(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="4" class="pt-3 role-filter-actions">
                  <v-btn
                    color="primary"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="GetRoleList()"
                    >{{ $t("message.Search") }}
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="OpenAddRoleDetailDialog()"
                    >{{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div>
            <v-card elevation="10" class="role-list-card">
              <v-card elevation="6" class="role-table-card">
                <div class="table-responsive">
                  <v-data-table
                    class="role-list-table"
                    :headers="headers"
                    :items="ListData"
                    hide-default-footer
                    :items-per-page="itemsPerPage"
                    :page.sync="page"
                    :mobile-breakpoint="0"
                    single-line
                    hide-details
                  >
                    <template
                      v-if="!$vuetify.breakpoint.smAndDown"
                      v-slot:item="{ item, index }"
                    >
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">{{ item.roleName }}</td>
                        <td class="header-table-css">{{ item.remark }}</td>
                        <td class="text-center">
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 120px"
                          >
                            <span :style="{ color: GetColorText(item.active) }">
                              {{
                                item.active
                                  ? $t("message.Active")
                                  : $t("message.InActive")
                              }}
                            </span>
                          </v-btn>
                        </td>
                        <td class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="orange"
                            @click="OpenRoleDetailDialog(item.roleID)"
                          >
                            <v-icon dark>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveRole(item.roleID)"
                          >
                            <v-icon dark>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template v-else v-slot:item="{ item, index }">
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">{{ item.roleName }}</td>
                        <td class="text-center">
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 100px"
                          >
                            <span :style="{ color: GetColorText(item.active) }">
                              {{ item.active ? "Active" : "InActive" }}
                            </span>
                          </v-btn>
                        </td>
                        <td class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="orange"
                            @click="OpenRoleDetailDialog(item.roleID)"
                          >
                            <v-icon dark>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveRole(item.roleID)"
                          >
                            <v-icon dark>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>

              <v-row class="mt-5 role-pagination-row" align="center">
                <v-col cols="12" md="8" lg="9" class="role-pagination-col">
                  <v-pagination
                    v-model="page"
                    :total-visible="paginationTotalVisible"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="role-page-size-col">
                  <v-autocomplete
                    class="role-page-size"
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="10/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="RoleDetailDialog"
      persistent
      max-width="900px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="rounded-xl elevation-4 role-dialog-card">
        <v-card-title
          class="d-flex align-center justify-space-between py-4 bg-primary text-white rounded-t-xl"
        >
          <span class="text-h6 font-weight-bold">{{
            $t("message.ManageRole")
          }}</span>
          <v-btn icon @click="CloseRoleDetailDialog()" class="text-white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6 role-dialog-content">
          <v-row dense>
            <v-col cols="12" md="2" v-if="EditStatus">
              <v-text-field
                :label="$t('message.RoleID')"
                v-model="RoleID"
                outlined
                dense
                disabled
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.RoleName')"
                v-model="RoleName"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                :label="$t('message.Remark')"
                v-model="Remark"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                :items="ProjectSiteList"
                item-value="projectID"
                item-text="projectName"
                :label="$t('message.ProjectSite')"
                v-model="ProjectSite"
                item-disabled="disabled"
                multiple
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <div class="text-subtitle-1 font-weight-bold text-primary mb-2">
            {{ $t("message.Permission") }}
          </div>
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.PreRegisterParking')"
                v-model="PreRegisterCarpark"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.WalkIn')"
                v-model="WalkIn"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.ManagePreRegister')"
                v-model="ManagePreRegisterCarpark"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.ManageUser')"
                v-model="ManageUserStatus"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.ManageRole')"
                v-model="ManageRole"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.ManageSection')"
                v-model="ManageApprover"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox
                color="primary"
                :label="$t('message.BlackListVisitor')"
                v-model="BlackListVisitor"
                hide-details
              />
            </v-col>
          </v-row>
          <div class="role-status-row">
            <v-radio-group row v-model="Active">
              <v-radio
                :label="$t('message.Active')"
                value="1"
                color="success"
              ></v-radio>
              <v-radio
                :label="$t('message.InActive')"
                value="2"
                color="error"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="role-dialog-actions">
          <v-btn
            v-if="EditStatus"
            color="success"
            class="white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="updateRole()"
          >
            {{ $t("message.Update") }}
          </v-btn>
          <v-btn
            v-else
            color="success"
            class="white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="updateRole()"
          >
            {{ $t("message.Create") }}
          </v-btn>

          <v-btn
            color="error"
            class="ml-2 white--text text-capitalize"
            width="120"
            :block="$vuetify.breakpoint.xsOnly"
            @click="CloseRoleDetailDialog()"
          >
            {{ $t("message.Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageRole",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      ListData: [],
      RoleDetailDialog: false,
      EditStatus: false,
      RoleID: 0,
      RoleName: "",
      Remark: "",

      RedemptionStatus: false,
      MyQRStatus: false,
      PreRegisterStatus: false,
      CallLiftStatus: false,
      ManageUserStatus: false,
      Active: null,

      PreRegisterCarpark: false,
      WalkIn: false,
      ManagePreRegisterCarpark: false,
      ManageRole: false,
      ManageApprover: false,
      BlackListVisitor: false,
      ProjectSiteList: [],
      ProjectSite: [],
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return [
          {
            text: this.$t("message.No"),
            sortable: false,
            align: "left",
          },
          {
            text: this.$t("message.RoleName"),
            align: "left",
            sortable: false,
          },
          {
            text: this.$t("message.Status"),
            align: "center",
            sortable: false,
          },
          {
            text: this.$t("message.Action"),
            align: "center",
            sortable: false,
          },
        ];
      }

      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Remark"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    paginationTotalVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 5;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return 7;
      }

      return 10;
    },
  },

  async mounted() {
    let self = this;
    await self.GetRoleList();
    await self.getDataDropdownProjectSite();
  },

  methods: {
    getDataDropdownProjectSite() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataDropdownProjectSite`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectSiteList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    GetRoleList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    SearchDataRoleList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    CloseRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      self.ProjectSite = [];
      self.RedemptionStatus = false;
      self.MyQRStatus = false;
      self.PreRegisterStatus = false;
      self.CallLiftStatus = false;
      self.ManageUserStatus = false;
      self.Active = null;
      self.PreRegisterCarpark = false;
      self.WalkIn = false;
      self.ManagePreRegisterCarpark = false;
      self.ManageRole = false;
      self.ManageApprover = false;
      self.BlackListVisitor = false;
      self.RoleDetailDialog = false;
    },

    OpenRoleDetailDialog(id) {
      let self = this;
      if (id != 0) {
        self.LoadingDialog = true;
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/getDatRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.BindingDataRole(response.data.data);
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    OpenAddRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      self.ProjectSite = [];
      self.RedemptionStatus = false;
      self.MyQRStatus = false;
      self.PreRegisterStatus = false;
      self.CallLiftStatus = false;
      self.ManageUserStatus = false;
      self.PreRegisterCarpark = false;
      self.WalkIn = false;
      self.ManagePreRegisterCarpark = false;
      self.ManageRole = false;
      self.ManageApprover = false;
      self.BlackListVisitor = false;
      self.Active = null;
      self.RoleDetailDialog = true;
    },

    BindingDataRole(data) {
      let self = this;
      self.EditStatus = true;
      self.RoleID = data.roleID;
      self.RoleName = data.roleName;
      self.Remark = data.remark;
      self.RedemptionStatus = data.permission.redemption;
      self.MyQRStatus = data.permission.qr;
      self.PreRegisterStatus = data.permission.preRegister;
      self.CallLiftStatus = data.permission.callLift;
      self.ManageUserStatus = data.permission.manageUser;
      self.Active =
        data.active == true ? "1" : data.active == false ? "2" : null;
      self.PreRegisterCarpark = data.permission.preRegisterParking;
      self.WalkIn = data.permission.preRegisterParkingWalkin;
      self.ManagePreRegisterCarpark = data.permission.managePreRegisterParking;
      self.ManageRole = data.permission.manageRole;
      self.ManageApprover = data.permission.approve;
      self.BlackListVisitor = data.permission.blackListVisitor;
      self.ProjectSite = self.NormalizeProjectSiteList(data.projectSite);
      self.RoleDetailDialog = true;
    },

    NormalizeProjectSiteList(projectSiteList) {
      if (!Array.isArray(projectSiteList)) {
        return [];
      }

      return projectSiteList
        .map((item) => {
          if (item && typeof item === "object") {
            return item.projectID || item.projectId;
          }

          return item;
        })
        .filter((projectID) => projectID !== null && projectID !== undefined);
    },

    updateRole() {
      let self = this;
      if (self.EditStatus == true) {
        self.LoadingDialog = true;
        let temp = {
          roleID: self.RoleID,
          roleName: self.RoleName,
          remark: self.Remark,
          redemptionStatus: self.RedemptionStatus,
          myQRStatus: self.MyQRStatus,
          preRegisterStatus: self.PreRegisterStatus,
          callLiftStatus: self.CallLiftStatus,
          manageUserStatus: self.ManageUserStatus,
          active: self.Active == "1" ? true : self.Active == "2" ? false : null,
          preRegisterCarpark: self.PreRegisterCarpark,
          walkIn: self.WalkIn,
          managePreRegisterCarpark: self.ManagePreRegisterCarpark,
          manageRole: self.ManageRole,
          manageApprover: self.ManageApprover,
          blackListVisitor: self.BlackListVisitor,
          projectSiteList: self.NormalizeProjectSiteList(self.ProjectSite),
        };
        axios
          .post(`${self.url}Management/updateRole`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.CloseRoleDetailDialog();
              self.GetRoleList();
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      } else {
        self.LoadingDialog = true;
        let temp = {
          roleName: self.RoleName,
          remark: self.Remark,
          redemptionStatus: self.RedemptionStatus,
          myQRStatus: self.MyQRStatus,
          preRegisterStatus: self.PreRegisterStatus,
          callLiftStatus: self.CallLiftStatus,
          manageUserStatus: self.ManageUserStatus,
          active: self.Active == "1" ? true : self.Active == "2" ? false : null,
          preRegisterCarpark: self.PreRegisterCarpark,
          walkIn: self.WalkIn,
          managePreRegisterCarpark: self.ManagePreRegisterCarpark,
          manageRole: self.ManageRole,
          manageApprover: self.ManageApprover,
          blackListVisitor: self.BlackListVisitor,
          projectSiteList: self.NormalizeProjectSiteList(self.ProjectSite),
        };
        axios
          .post(`${self.url}Management/addRole`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.page = 1;
              self.CloseRoleDetailDialog();
              self.GetRoleList();
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    InActiveRole(id) {
      let self = this;
      if (id != 0) {
        self.LoadingDialog = true;
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/inActiveRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetRoleList();
            }
          })
          .catch(function (error) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.manage-role-page {
  margin-left: 10px;
  margin-right: 10px;
}

.role-filter-card,
.role-list-card {
  padding: 2%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.role-filter-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.role-table-card {
  padding: 16px;
  margin-bottom: 16px;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.role-list-table {
  min-width: 760px;
  color: #332f2fde;
}

.role-pagination-col {
  display: flex;
  justify-content: center;
}

.role-page-size-col {
  display: flex;
  justify-content: flex-end;
}

.role-page-size {
  max-width: 180px;
}

.role-status-row {
  display: flex;
  justify-content: flex-end;
}

.role-dialog-card {
  overflow: hidden;
}

.role-dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

@media (max-width: 959px) {
  .role-list-table {
    min-width: 560px;
  }

  .role-page-size-col {
    justify-content: center;
  }

  .role-page-size {
    max-width: 220px;
  }
}

@media (max-width: 599px) {
  .manage-role-page {
    margin-left: 0;
    margin-right: 0;
  }

  .role-filter-card,
  .role-list-card {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .role-filter-actions {
    display: block;
    padding-top: 0 !important;
  }

  .role-table-card {
    padding: 8px;
  }

  .role-list-table {
    min-width: 520px;
  }

  .role-dialog-card {
    border-radius: 0 !important;
  }

  .role-dialog-content {
    padding: 16px !important;
  }

  .role-status-row {
    justify-content: flex-start;
  }

  .role-dialog-actions {
    display: block;
    padding: 16px;
  }

  .role-dialog-actions .v-btn {
    margin-left: 0 !important;
    margin-top: 8px;
  }
}
</style>
  
